// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-container {
  cursor: grab;
}
.swiper-container:active {
  cursor: grabbing;
}

.swiper-button-prev,
.swiper-button-next {
  bottom: 2rem;
  top: initial;
  translate: 0 0.75rem;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 1.75rem;
}
@media only screen and (max-width: 1199px) {
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
}
.swiper-button-prev:focus, .swiper-button-prev:active,
.swiper-button-next:focus,
.swiper-button-next:active {
  color: var(--primary-color) !important;
}
.swiper-button-prev:hover,
.swiper-button-next:hover {
  background: transparent !important;
  color: var(--primary-color) !important;
}

.swiper-button-prev {
  right: 14rem;
  left: initial;
}
@media only screen and (max-width: 1199px) {
  .swiper-button-prev {
    right: initial;
    left: 1.5rem;
    bottom: 4rem;
  }
}
.swiper-button-prev svg {
  right: 3px;
}

.swiper-button-next {
  right: 8rem;
}
@media only screen and (max-width: 1199px) {
  .swiper-button-next {
    right: initial;
    left: 6.5rem;
    bottom: 4rem;
  }
}
.swiper-button-next svg {
  left: 3px;
}

:host ::ng-deep .swiper-pagination {
  bottom: 2rem !important;
  left: 2rem !important;
  right: initial;
  width: -moz-fit-content !important;
  width: fit-content !important;
}

:host ::ng-deep .swiper-pagination-bullet {
  width: 1rem;
  border-radius: 8px;
  background: white;
  height: 6px;
  transition: width 0.2s ease-in;
}
:host ::ng-deep .swiper-pagination-bullet-active {
  transition: width 0.2s ease-in;
  background: var(--primary-color);
  width: 5rem;
  border-radius: 8px;
  height: 6px;
}

.image-container {
  object-fit: cover;
  object-position: center;
}
.image-container .blur {
  filter: blur(10px);
}
.image-container img {
  transition: filter 0.3s ease-in-out;
  object-fit: cover;
}

.autoplay-progress {
  right: 9.5rem;
  bottom: -2px;
  z-index: 10;
  width: 48px;
  height: 48px;
  translate: -50% -50%;
  color: var(--surface-900);
}
@media only screen and (max-width: 1199px) {
  .autoplay-progress {
    display: none !important;
  }
}

.autoplay-progress svg {
  --progress: 0;
  z-index: 10;
  stroke-width: 4px;
  stroke: var(--primary-color);
  fill: none;
  stroke-dashoffset: calc(125.6 * (1 - var(--progress)));
  stroke-linecap: round;
  stroke-dasharray: 125.6;
  transform: rotate(-90deg);
}

.carousel-citation {
  height: 40%;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6) 50%, transparent 100%);
  color: #fff;
}
.carousel-citation p:first-child {
  width: -moz-fit-content;
  width: fit-content;
}
.carousel-citation p:first-child span {
  font-family: "Times New Roman", serif;
  font-size: 90px;
  top: 2.5rem;
  line-height: 0rem;
}
.carousel-citation p:first-child span:first-child {
  margin-right: 1rem;
  top: 1.5rem;
}
.carousel-citation p:first-child span:last-of-type {
  top: 3.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/login-slider-unsplash/login-slider-unsplash.component.scss"],"names":[],"mappings":"AAMA;EACE,YAAA;AALF;AAOE;EACE,gBAAA;AALJ;;AASA;;EAEE,YAAA;EACA,YAAA;EACA,oBAAA;AANF;AAQE;;EACE,kBAAA;AALJ;AAfE;EAaF;;IAoBI,aAAA;EAbF;AACF;AAeE;;;EAEE,sCAAA;AAZJ;AAeE;;EACE,kCAAA;EACA,sCAAA;AAZJ;;AAgBA;EACE,YAAA;EACA,aAAA;AAbF;AApCE;EA+CF;IAKI,cAAA;IACA,YAAA;IACA,YAAA;EAZF;AACF;AAcE;EACE,UAAA;AAZJ;;AAgBA;EACE,WAAA;AAbF;AAlDE;EA8DF;IAII,cAAA;IACA,YAAA;IACA,YAAA;EAZF;AACF;AAcE;EACE,SAAA;AAZJ;;AAgBA;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,kCAAA;EAAA,6BAAA;AAbF;;AAiBE;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;AAdJ;AAiBE;EACE,8BAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAfJ;;AAmBA;EACE,iBAAA;EACA,uBAAA;AAhBF;AAkBE;EACE,kBAAA;AAhBJ;AAmBE;EACE,mCAAA;EACA,iBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;AAlBF;AAxGE;EAmHF;IAaI,wBAAA;EApBF;AACF;;AAuBA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,UAAA;EACA,sDAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;AApBF;;AAuBA;EACE,WAAA;EAEA,mFAAA;EAKA,WAAA;AAzBF;AA2BE;EACE,uBAAA;EAAA,kBAAA;AAzBJ;AA2BI;EACE,qCAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAzBN;AA2BM;EACE,kBAAA;EACA,WAAA;AAzBR;AA4BM;EACE,WAAA;AA1BR","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.swiper-container {\r\n  cursor: grab;\r\n\r\n  &:active {\r\n    cursor: grabbing;\r\n  }\r\n}\r\n\r\n.swiper-button-prev,\r\n.swiper-button-next {\r\n  bottom: 2rem;\r\n  top: initial;\r\n  translate: 0 0.75rem;\r\n\r\n  &:after {\r\n    font-size: 1.75rem;\r\n  }\r\n\r\n  @include md() {\r\n    // width: 1.5rem;\r\n    // height: 1.5rem;\r\n    // padding: 0.5rem;\r\n    // translate: 0 0rem;\r\n    // bottom: 6rem;\r\n\r\n    // &:after {\r\n    //   font-size: 1.5rem;\r\n    // }\r\n    display: none;\r\n  }\r\n\r\n  &:focus,\r\n  &:active {\r\n    color: var(--primary-color) !important;\r\n  }\r\n\r\n  &:hover {\r\n    background: transparent !important;\r\n    color: var(--primary-color) !important;\r\n  }\r\n}\r\n\r\n.swiper-button-prev {\r\n  right: 14rem;\r\n  left: initial;\r\n\r\n  @include md() {\r\n    right: initial;\r\n    left: 1.5rem;\r\n    bottom: 4rem;\r\n  }\r\n\r\n  svg {\r\n    right: 3px;\r\n  }\r\n}\r\n\r\n.swiper-button-next {\r\n  right: 8rem;\r\n\r\n  @include md() {\r\n    right: initial;\r\n    left: 6.5rem;\r\n    bottom: 4rem;\r\n  }\r\n\r\n  svg {\r\n    left: 3px;\r\n  }\r\n}\r\n\r\n:host ::ng-deep .swiper-pagination {\r\n  bottom: 2rem !important;\r\n  left: 2rem !important;\r\n  right: initial;\r\n  width: fit-content !important;\r\n}\r\n\r\n:host ::ng-deep {\r\n  .swiper-pagination-bullet {\r\n    width: 1rem;\r\n    border-radius: 8px;\r\n    background: white;\r\n    height: 6px;\r\n    transition: width 0.2s ease-in;\r\n  }\r\n\r\n  .swiper-pagination-bullet-active {\r\n    transition: width 0.2s ease-in;\r\n    background: var(--primary-color);\r\n    width: 5rem;\r\n    border-radius: 8px;\r\n    height: 6px;\r\n  }\r\n}\r\n\r\n.image-container {\r\n  object-fit: cover;\r\n  object-position: center;\r\n\r\n  .blur {\r\n    filter: blur(10px);\r\n  }\r\n\r\n  img {\r\n    transition: filter 0.3s ease-in-out;\r\n    object-fit: cover;\r\n  }\r\n}\r\n\r\n.autoplay-progress {\r\n  right: 9.5rem;\r\n  bottom: -2px;\r\n  z-index: 10;\r\n  width: 48px;\r\n  height: 48px;\r\n  translate: -50% -50%;\r\n  color: var(--surface-900);\r\n\r\n  @include md() {\r\n    // right: initial;\r\n    // left: 5rem;\r\n    // bottom: calc(2.25rem - 2px);\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.autoplay-progress svg {\r\n  --progress: 0;\r\n  z-index: 10;\r\n  stroke-width: 4px;\r\n  stroke: var(--primary-color);\r\n  fill: none;\r\n  stroke-dashoffset: calc(125.6 * (1 - var(--progress)));\r\n  stroke-linecap: round;\r\n  stroke-dasharray: 125.6;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.carousel-citation {\r\n  height: 40%;\r\n\r\n  background-image: linear-gradient(\r\n    to top,\r\n    rgba(0, 0, 0, 0.6) 50%,\r\n    transparent 100%\r\n  );\r\n  color: #fff;\r\n\r\n  p:first-child {\r\n    width: fit-content;\r\n\r\n    span {\r\n      font-family: \"Times New Roman\", serif;\r\n      font-size: 90px;\r\n      top: 2.5rem;\r\n      line-height: 0rem;\r\n\r\n      &:first-child {\r\n        margin-right: 1rem;\r\n        top: 1.5rem;\r\n      }\r\n\r\n      &:last-of-type {\r\n        top: 3.5rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
